import { IconTruckDryvan, IconTruckFlatbed, IconTruckReefer } from '@loadsmart/icons'

const ICON_SIZE = 24

export const ftlEquipmentTypes = [
  {
    icon: <IconTruckDryvan height={ICON_SIZE} width={ICON_SIZE} />,
    label: 'Dry Van',
    value: 'DRV',
  },
  {
    icon: <IconTruckReefer height={ICON_SIZE} width={ICON_SIZE} />,
    label: 'Reefer',
    value: 'RFR',
  },
  {
    icon: <IconTruckFlatbed height={ICON_SIZE} width={ICON_SIZE} />,
    label: 'Flatbed',
    value: 'FBE',
  },
]
